<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 17:16:26
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-08 18:46:35
-->
<template>
  <div>
    <p class="fz-14 yx-color-text-primary yx-pingfang-semibold flex-row flex-align-center flex-just-start"><i class="status-icon mr-6" :class="curObj.styleClass"></i>{{curObj.cellText}}</p>
  </div>
</template>
<script>
import mixin from './mixin';
import {palletStatus} from '@/utils/dataMap';
export default {
  mixins: [mixin],
  computed: {
    curObj() {
      return palletStatus[this.row.status];
    }
  }
}
</script>